import Objectives from './Objectives';

export default Objectives;
